export default __webpack_public_path__ + "locales/sr-Cyrl-RS/JavascriptSdk.json?hash=1ce334daa148930fac5bd180d96d30b4";